import React, {Component} from 'react';

export default class UnparalleledBusinessBenefit extends Component {
    render(){
        return(
            <div className='gr-12 unparalleled-business-benefit'>
                <div className='row'>
                    <div className='gr-12 unparalleled-business-benefit-text'>
                        <h1>Unparalleled business benefit</h1>
                        <p>Social Native powers results-oriented marketers with a platform built on three core principals: targeting, automating and saving.</p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/unparalleled_business_benefit.js